import { clamp } from '../lib/format';
import styles from './SpectrumGauge.module.css';

interface Props {
  value: number; // -1..1
  height?: number;
  showLabels?: boolean;
  className?: string;
}

export function SpectrumGauge({ value, height = 8, showLabels = true, className }: Props) {
  const clamped = clamp(value, -1, 1);
  const pct = ((clamped + 1) / 2) * 100;

  return (
    <div className={[styles.wrap, className].filter(Boolean).join(' ')}>
      <div className={styles.barRow} style={{ height }}>
        <svg
          className={styles.bar}
          viewBox={`0 0 100 ${height}`}
          preserveAspectRatio="none"
          height={height}
          role="img"
          aria-label={`Sentiment ${value.toFixed(2)} on a scale from -1 to +1`}
        >
          <defs>
            <linearGradient id="spectrumGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="var(--tia-negative)" />
              <stop offset="50%" stopColor="var(--tia-grey-300)" />
              <stop offset="100%" stopColor="var(--tia-positive)" />
            </linearGradient>
          </defs>
          <rect
            x="0"
            y="0"
            width="100"
            height={height}
            fill="url(#spectrumGradient)"
            rx={height / 2}
            ry={height / 2}
          />
        </svg>
        <span
          className={styles.marker}
          style={{ left: `${pct}%` }}
          aria-hidden="true"
        />
      </div>
      {showLabels && (
        <div className={styles.labels}>
          <span>Bearish (−1.0)</span>
          <span>Neutral (0.0)</span>
          <span>Bullish (+1.0)</span>
        </div>
      )}
    </div>
  );
}
